<template>
  <div class="user-center-page">
    <EsHeaderView />
    <div class="container-box">
      <div class="page-main app-container">
        <navBar />
        <div class="set-container">
          <router-view />
        </div>
      </div>
    </div>
    <EsFooterView />
  </div>
</template>
<script>
  import navBar from "./navBar.vue";
  export default {
    components: {
      navBar,
    },
  };
</script>
<style lang="scss" scoped>
html[dir="rtl"] {
  :deep(.info_page_container) {
    margin-left: 0;
    margin-right: 34px;
  }
}

.user-center-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  width: 100%;

  :deep(.footer) {
    width: 100%;
    align-self: stretch;
  }
}

.container-box {
  flex: 1;
  width: 100%;
  background: #f5f5f5;
}

.page-main {
  width: 1200px;
  max-width: 100%;
  margin: 0 auto;
  padding: 30px 0 50px;
  display: flex;
  align-items: flex-start;
  box-sizing: border-box;

  .set-container {
    flex: 1;
    min-width: 0;
  }
}

:deep(.info_page_container) {
  margin-top: 24px;
  margin-left: 34px;
}

:deep(.page-title) {
  font-weight: 700;
  font-size: 24px;
  color: #333;
}
</style>
